import script from "./CameraFootage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraFootage.vue?vue&type=script&lang=ts&setup=true"

import "./CameraFootage.vue?vue&type=style&index=0&id=60bd22b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60bd22b4"]])

export default __exports__